import React from "react";
import { Spring, config } from "react-spring/renderprops";
import Konva from "konva";
import { Arc, Stage, Layer, Text, Rect, Shape } from "react-konva";
import ReactResizeDetector from "react-resize-detector";
import ResizeableStage from "charts/ResizeableStage";
import MetricFormatter from "dashboards/MetricFormatter";
import ReactDOMServer from "react-dom/server";
import jsDig from "utils/jsDig";
import { startCase, camelCase } from "lodash";
import GetFormatter from "dashboards/GetFormatter";

const colors = [
  "#2c345b ",
  "#3291c1",
  "#42ba96",
  "#dbb13b",
  "#a3a3a3",
  "#55588f",
  "#65abcf",
  "#6fc9ad",
  "#e1c474",
  "#cacaca",
  "#7b7da4",
  "#97c4db",
  "#9fd8c7",
  "#e7d29b",
];
class ChartPie extends React.Component {
  constructor(props) {
    super(props);

    this.textSizeScalar = 0.11;
    this.strokeScalar = 0.08;

    // The graph actually shows only spend except on hover
    this.slices = jsDig(["spend"], this.props.data) ? Object.keys(jsDig(["spend"], this.props.data)) : [];
    this.slices = this.slices.filter((slice) => jsDig(["spend", slice], this.props.data) > 0);
    this.total = 0;
    this.slices.forEach((slice) => {
      this.total += jsDig(["spend", slice], this.props.data);
    });
    if (this.total === 0) this.total = 1;

    this.slicePercentages = {};
    this.slices.forEach((slice) => {
      this.slicePercentages[slice] = jsDig(["spend", slice], this.props.data) / this.total;
    });

    this.state = {
      tooltipText: "",
    };
  }

  componentDidMount() {
    const tooltipElement = $("#" + this.props.id).get(0);
    if (tooltipElement) {
      tooltipElement.setAttribute("data-toggle", "tooltip");
      tooltipElement.setAttribute("data-trigger", "manual");
      tooltipElement.setAttribute("data-placement", "auto");
      tooltipElement.setAttribute("data-html", "true");
      tooltipElement.setAttribute("data-original-title", "");
      tooltipElement.setAttribute("data-custom-class", "geoMapTooltip");
      tooltipElement.setAttribute(
        "data-template",
        '<div class="tooltip geoMapTooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
      );
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.textSizeScalar = 0.11;
      this.strokeScalar = 0.08;

      // The graph actually shows only spend except on hover
      this.slices = jsDig(["spend"], this.props.data) ? Object.keys(jsDig(["spend"], this.props.data)) : [];
      this.slices = this.slices.filter((slice) => jsDig(["spend", slice], this.props.data) > 0);
      this.total = 0;
      this.slices.forEach((slice) => {
        this.total += jsDig(["spend", slice], this.props.data);
      });
      if (this.total === 0) this.total = 1;

      this.slicePercentages = {};
      this.slices.forEach((slice) => {
        this.slicePercentages[slice] = jsDig(["spend", slice], this.props.data) / this.total;
      });

      this.setState({
        tooltipText: "",
      });
    }
  }
  render() {
    return (
      <div className="p-1" id={this.props.id}>
        <ResizeableStage
          maxHeight={400}
          pdfDim={this.props.pdfDim}
          render={(width, height) => {
            const wOrH = height > width ? width : height;
            const strokeWidth = this.strokeScalar * wOrH;
            const radius = wOrH / 2.1 - strokeWidth / 1.8;

            const hW = width / 2;
            const hH = height / 2;
            let allText = "";
            this.slices.forEach((slice) => {
              allText += `${slice.charAt(0).toUpperCase() + slice.slice(1)}: ${ReactDOMServer.renderToString(
                <MetricFormatter.YY0 value={this.slicePercentages[slice] * 100} />
              )}\n`;
            });
            return (
              <>
                {this.slices.map((slice, i) => {
                  let previousAccumulation = 0;
                  this.slices.some((s) => {
                    if (s == slice) return true;
                    else {
                      previousAccumulation += this.slicePercentages[s];
                    }
                  });

                  const sliceAngle = this.slicePercentages[slice] * 360;
                  const startAngle = previousAccumulation * 360;

                  const textYPadding = height / 28;
                  const spaceTaken = radius * this.textSizeScalar * this.slices.length + textYPadding * this.slices.length;

                  return (
                    <React.Fragment key={slice}>
                      <Spring config={config.molasses} delay={0} from={!this.props.pdfDim ? { angle: 0 } : undefined} to={{ angle: sliceAngle }}>
                        {(props) => (
                          <Arc
                            x={hW}
                            y={hH}
                            innerRadius={radius}
                            outerRadius={radius}
                            angle={props.angle}
                            fill="rgba(0,0,0,0)"
                            stroke={colors[i]}
                            lineCap="butt"
                            lineJoin="butt"
                            rotation={-90 + startAngle}
                            strokeWidth={strokeWidth}
                            onMouseEnter={() => {
                              const sliceTitle = _.startCase(_.camelCase(slice));
                              let newText = `${sliceTitle}<br>`;
                              this.props.metricsEnabled.forEach((metricKey, index) => {
                                let Formatter = GetFormatter({ metricName: metricKey });
                                const metricTitle = _.startCase(_.camelCase(metricKey));
                                const metricValue = ReactDOMServer.renderToString(<Formatter value={jsDig([metricKey, slice], this.props.data)} baseCurrency={this.props.baseCurrency} displayCurrency={this.props.displayCurrency} />);
                                newText += `${metricTitle}: ${metricValue}${index < this.props.metricsEnabled.length ? "<br>" : ""}`;
                              });
                              this.setState({ tooltipText: newText });
                              const tooltipElement = $("#" + this.props.id).get(0);
                              tooltipElement.setAttribute("data-original-title", this.state.tooltipText);
                              $("#" + this.props.id).tooltip("show");
                            }}
                            onMouseLeave={() => {
                              $("#" + this.props.id).tooltip("hide");
                            }}
                          />
                        )}
                      </Spring>
                      <Text
                        text={`${slice.charAt(0).toUpperCase() + slice.slice(1)}: ${ReactDOMServer.renderToString(
                          <MetricFormatter.YY0 value={this.slicePercentages[slice] * 100} />
                        )}`}
                        x={0}
                        y={height / 2 - spaceTaken / 2 + (i * textYPadding + i * radius * this.textSizeScalar)}
                        width={width}
                        offsetX={-width / 2.6}
                        height={radius / 10}
                        fontSize={radius * this.textSizeScalar}
                        align="left"
                        verticalAlign="middle"
                        fill="#212348"
                        fontFamily="visby-extra-bold"
                      />
                      <Rect
                        text={`${slice.charAt(0).toUpperCase() + slice.slice(1)}: ${ReactDOMServer.renderToString(
                          <MetricFormatter.YY0 value={this.slicePercentages[slice] * 100} />
                        )}`}
                        x={width / 3}
                        y={height / 2 - spaceTaken / 2 + (i * textYPadding + i * radius * this.textSizeScalar)}
                        width={width / 30}
                        height={width / 30}
                        fontSize={radius * this.textSizeScalar}
                        align="left"
                        verticalAlign="middle"
                        fill={colors[i]}
                        fontFamily="nunito-sans-bold"
                      />
                    </React.Fragment>
                  );
                })}
              </>
            );
          }}></ResizeableStage>
      </div>
    );
  }
}

export default ChartPie;
